<template>
<div class="sign-in" id="signin">
    <div class="signIn_block">
        <div class="signIn_block-content">
            <div class="left_block">
                <img class="leftImg" src="./img/chatu.png" alt="">
            </div>
            <div class="operation">
                <el-form ref="form" :model="form" :rules="formRules">
                    <el-form-item class="title">
                        <h3>康仁堂学术平台</h3>
                    </el-form-item>
                    <el-form-item class="login_input" prop='username'>
                        <div class="login-item" ref="username">
                            <img class="icon_account" src="./img/account.png" alt="">
                            <el-input v-model="form.username" maxlength="11" placeholder="账号" @blur="inputBlur('username')"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item class="login_input vericode" prop='password'>
                        <div class="login-item" ref="password" style="width:220px !important;">
                            <img class="icon_pwd" src="./img/pwd.png" alt="">
                            <el-input v-model="form.vericode" placeholder="验证码" @blur="inputBlur('password')"></el-input>
                        </div>
                        <el-button size="mini" class="getcode" :disabled="!codeState" @click="getCode">{{codeState?'获取验证码':countDownNum + '秒之后重新发送'}}</el-button>
                    </el-form-item>
                    <el-form-item style="text-align:center;">
                        <el-button class="el-button" type="primary" @click="onSubmit">登录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
    <!-- <div class="sign_bottom">
        © 2020 康仁堂 版权所有
    </div> -->
    <!-- <div class="sign-in_bac">
        <img class="bac" src="./img/bg.png" alt="">
    </div> -->
</div>
</template>

<script>
export default {
    name: 'signIn',
    data() {
        return {
            token: '',
            form: {
                //账号
                username: "",
                //验证码
                vericode: ""
            },
            formRules: {
                username: [{
                    required: true,
                    message: '账号不能为空！',
                    trigger: 'blur'
                }],
                vericode: [{
                    required: true,
                    message: '验证码不能为空！',
                    trigger: 'blur'
                }]
            },
            codeState: true,
            countDownNum: 180
        }
    },
    created() {
        sessionStorage.clear()
    },
    mounted() {
        document.getElementById('signin').style.height = document.body.clientHeight + 'px'
    },
    methods: {
        //获取验证码
        getCode() {
            this.codeState = false
            let that = this
            if (this.form.username.toString().trim() == "") {
                this.$message.error('请输入手机号');
                this.codeState = true
                return
            }
            let testPhone = /^(((13[0-9]{1})|(15[0-9]{1})|(14[0-9]{1})|(16[0-9]{1})|(92[0-9]{1})|(98[0-9]{1})|(18[0-9]{1})|(19[0-9]{1})|(17[0-9]{1}))+\d{8})$/
            if (!testPhone.test(this.form.username.toString().trim())) {
                this.$message.error('请输入正确的手机号');
                this.codeState = true
                return
            }
            this.$api.verificationCode({
                mobilePhone: this.form.username.toString().trim(),
                type: 'ADMIN_LOGIN'
            }).then(res => {
                console.log(res)
                this.countDown(this.countDownNum)
            })
        },
        //倒计时
        countDown(n) {
            let that = this
            if (n > 0) {
                this.codeState = false
                n--
                this.countDownNum = n
                setTimeout(() => {
                    that.countDown(n)
                }, 1000);
            } else {
                this.countDownNum = 180
                this.codeState = true
            }
        },
        //提交
        onSubmit() {
            let that = this
            that.$refs.form.validate(valid => {
                // 都非空
                if (valid) {
                    let params = {
                        mobilePhone: that.form.username,
                        verificationCode: that.form.vericode
                    }
                    this.$api.adminLogin(params).then(res => {
                        console.log('login', res)
                        if (res.status == "OK") {
                            sessionStorage.setItem('accountInfo', JSON.stringify(res.data))
                            sessionStorage.setItem('token', res.data.jwtToken)
                            this.$router.push({
                                path: '/'
                            })
                        } else {
                            this.$message.error(res.errorMsg);
                        }
                    }).catch(err => {
                        this.$message.error(err);
                    })
                } else {
                    that.$refs.username.style.borderBottom = '1px solid #F56C6C'
                    that.$refs.password.style.borderBottom = '1px solid #F56C6C'
                }
            })
        },
        inputBlur(type) {
            if (this.form[type] == '') {
                this.$refs[type].style.borderBottom = '1px solid #F56C6C'
            } else {
                this.$refs[type].style.borderBottom = '1px solid #d8d8d8'
            }
        }
    }
}
</script>

<style>
/* SignIn.vue 样式 */
@import url('./css/SignIn.css');
/* SignIn.vue End */
</style>
